import React from 'react';
import { Box } from '@mui/material';
import { MailOutline, PhoneInTalkOutlined } from '@mui/icons-material';
import { ContactInfoRow } from '../../../../../molecules';
import { Loader } from '../../../../../Loader';
import { useProviderContacts } from './ProviderCardContacts.hooks';
import { ContactType } from '@uplift/types';


const contactTypeToIconMap = {
  [ContactType.email]: MailOutline,
  [ContactType.phone]: PhoneInTalkOutlined,
};


export type ProviderCardContactsProps = {
  providerId?: string;
  visible?: boolean;
};

export const ProviderCardContacts: React.VFC<ProviderCardContactsProps> = ({
  providerId,
  visible = true,
}) => {
  const { data: contacts, isLoading: isContactsLoading } = useProviderContacts(providerId, visible);

  if (isContactsLoading) {
    return (
      <Loader height="72px" size="24px" color="secondary" />
    );
  }

  const displayContacts = contacts?.filter(x => x.name !== 'email');

  return (
    <Box px={2} py={1} display="flex" flexDirection="column" gap="8px">
      {displayContacts?.map(contact => (
        <ContactInfoRow
          key={contact.id}
          icon={contactTypeToIconMap[contact.type]}
          primary={contact.value}
          secondary={contact.name}
          text={contact.value}
        />
      ))}
    </Box>
  );
};
